/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import styled from 'styled-components';

import Text from '@components/Text';

import { getEnv } from '@config';

const { publicPath } = getEnv();

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ErrorMessage = styled(Text).attrs({
  color: 'gray800',
  type: 'Body-2-w400',
  element: 'p',
  align: 'center',
})`
  margin: 0;
  margin-top: 24px;
  max-width: 264px;
`;

const Image = styled.img``;

const LinkText = styled(Text)`
  margin-top: 16px;
  cursor: pointer;
`;

export default function ({ closeError, cant }) {
  const handleClose = () => {
    closeError();
  };

  return (
    <Container>
      <Image src={`${publicPath}/ils-error.svg`} />
      <ErrorMessage>
        La cantidad de archivos seleccionados supera el límite de {cant} archivos
      </ErrorMessage>
      <LinkText element="a" type="Body-2-w400" color="gbrand500" onClick={handleClose}>
        Volver a cargar
      </LinkText>
    </Container>
  );
}
